import { getGridMode } from "../getGridMode.ts";
import type { ChartStyleSettings } from "../../../../../../../../api/types/svTypes.ts";

export function getArgumentAxisGrid(settings: ChartStyleSettings) {
  const gridMode = getGridMode(settings);
  return { visible: gridMode === "all" };
}

export function getValueAxisGrid(settings: ChartStyleSettings) {
  const gridMode = getGridMode(settings);
  return { visible: gridMode === "horizontal" || gridMode === "all" };
}
